import { routes } from 'Routes'
import humps from 'humps'

const getHomePageByPermission = (permissions = []) => {
  const priorityList = {
    root: routes.root,
    dataProcesses: routes.dataProcess.all,
    organizations: routes.organizations.all,
    companies: routes.companies.all,
    users: routes.users.all,
    userCollaborators: routes.collaborators.all,
    preRegistrations: routes.preRegistrations.all,
    ssoCorporateGroups: routes.ssoCorporateGroups.all,
    backofficeGovernanceProject: routes.governanceProjects.all,
    integrationPartners: routes.integrationPartner.all,
    lastUpdates: routes.lastUpdates.all,
    companySuppliers: routes.suppliers.all,
    departments: routes.departments.all,
    clientProfiles: routes.userProfiles.all,
    collaboratorProfiles: routes.collaboratorProfiles.all,
    privacyPolicy: routes.privacyPolicy.all,
    allQuestionnaires: routes.questionnaires.all,
    paymentContracts: routes.contracts.all,
    paymentOrders: routes.paymentOrders.all,
    sellers: routes.sellers.all,
    plans: routes.plans.all,
    discountCoupons: routes.coupons.all,
    churn: routes.churns.all,
    groups: routes.groups.all,
    subgroups: routes.subgroups.all,
    segments: routes.segments.all,
    economicActivities: routes.economicActivities.all,
    companySizes: routes.companySizes.all,
  }

  const availableRoutes = camelizeArray(
    permissions
      .filter(filterByStatus)
      .filter(filterByList)
      .map((item) => item.tag),
  )

  for (let key in priorityList) {
    const newRoute = findByKey(availableRoutes, key)
    if (newRoute) {
      return priorityList[newRoute]
    }
  }
  return routes.noPermissions
}

// Tags de listagem usam dois prefixos no projeto: `list_` (maioria) e `index_`
// (padrão dos módulos mais novos, como parceiros de integração).
const LIST_TAG_PREFIX = /^(list|index)_/

const filterByStatus = (obj) => obj?.status
const filterByList = (obj) => LIST_TAG_PREFIX.test(obj?.tag ?? '')
const findByKey = (arr, key) => arr.find((item) => item === key)
const camelizeArray = (arr) =>
  arr.map((str) => humps.camelize(str?.replace(LIST_TAG_PREFIX, '')))

export default getHomePageByPermission
